import React from 'react';

const getPoint = ([x, y]) => `${x},${y}`;

const getDiamondPoints = (x, y, radius) => (
  [
    [x - radius, y],
    [x, y + radius],
    [x + radius, y],
    [x, y - radius],
  ].map(getPoint)
    .join(' ')
);

const Dot = ({
  cx,
  cy,
  stroke,
  index,
  highlights,
  radius,
} = {}) => {
  switch (index) {
    case highlights.currentIndex:
      return (
        <circle
          cx={cx}
          cy={cy}
          r={radius}
          fill={stroke}
          stroke="#FFF"
          strokeWidth="1"
        />
      );
    case highlights.maxIndex:
      return (
        <polygon
          points={getDiamondPoints(cx, cy, radius)}
          fill="#5EAB1D"
          stroke="#FFF"
          strokeWidth="1"
        />
      );
    case highlights.minIndex:
      return (
        <polygon
          points={getDiamondPoints(cx, cy, radius)}
          fill="#CE3E37"
          stroke="#FFF"
          strokeWidth="1"
        />
      );
    default:
      return null;
  }
};

export default Dot;
